import React from "react";

const SectionBreak = ({ variant = "wave" }) => {
  // Wave variant - smooth flowing divider
  return (
    <div className="relative py-10 bg-white">
      <div className="absolute inset-x-0 top-1/2 h-px bg-gradient-to-r from-transparent via-[#E78730] to-transparent" />

      <div className="relative text-center">
        <span className="inline-block bg-white px-6 text-sm font-semibold tracking-wide uppercase text-gray-500">
          What We Do
        </span>
      </div>
    </div>
  );
};

export default SectionBreak;
